export default "__VITE_ASSET__DY991GqZ__"